import type { AuthStatus } from '@val/shared'
import { useCallback, useEffect, useState } from 'react'
import { login as apiLogin, logout as apiLogout, fetchAuthStatus } from '../lib/api.ts'

export function useAuth() {
  const [status, setStatus] = useState<AuthStatus | null>(null)

  const refresh = useCallback(async () => {
    setStatus(await fetchAuthStatus())
  }, [])

  useEffect(() => {
    refresh()
  }, [refresh])

  const login = useCallback(async (u: string, p: string) => {
    const s = await apiLogin(u, p)
    setStatus(s)
    return s
  }, [])

  const logout = useCallback(async () => {
    await apiLogout()
    setStatus({ authenticated: false })
  }, [])

  return {
    status,
    authenticated: status?.authenticated ?? false,
    isAdmin: status?.isAdmin ?? false,
    username: status?.username,
    ready: status !== null,
    login,
    logout,
    refresh,
  }
}
